module.exports = __webpack_public_path__ + "media/images/emblems/Wattenwil-coat_of_arms-93368697cfa14dbaf1596cfd0b5f7644.svg";